"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthWrapper = void 0;
var react_1 = require("react");
var AuthWrapper = function (props) {
    var consumer = props.consumer, children = props.children;
    var _a = react_1.useState(null), tokens = _a[0], setTokens = _a[1];
    var _b = react_1.useState(null), error = _b[0], setError = _b[1];
    react_1.useEffect(function () {
        if (tokens) {
            return;
        }
        consumer
            .getTokens()
            .then(function (storedTokens) {
            if (storedTokens) {
                if (consumer.isTokenExpired(storedTokens.accessToken)) {
                    // nest condition to prevent an extra 'decode' if not necessary
                    if (!consumer.isTokenExpired(storedTokens.refreshToken)) {
                        return consumer
                            .refreshTokens(storedTokens)
                            .then(function (newTokens) {
                            setTokens(newTokens);
                        })
                            .catch(function (e) { return setError(e); });
                    }
                    // if refresh expired, just continue on to get all new tokens
                }
                else {
                    setTokens(storedTokens);
                    return;
                }
            }
            // check for authCode query params
            var _a = consumer.getParsedQuery(), authCode = _a.authCode, authState = _a.authState;
            if (authCode && authState) {
                // retrieve token
                consumer
                    .createTokens(authCode, authState)
                    .then(function (newTokens) {
                    setTokens(newTokens);
                    consumer.navigate(consumer.getCurrentUri(), true);
                })
                    .catch(function (e) { return setError(e); });
            }
            else {
                // if not authCode, redirect to login
                consumer
                    .getLoginUri(consumer.getCurrentUri())
                    .then(function (uri) {
                    consumer.navigate(uri);
                })
                    .catch(function (e) { return setError(e); });
            }
        })
            .catch(function (e) { return setError(e); });
    }, [tokens]);
    return children(tokens, error);
};
exports.AuthWrapper = AuthWrapper;
